"use client";

import { useState } from "react";
import {
  FacebookLogoIcon,
  XLogoIcon,
  WhatsappLogoIcon,
  LinkedinLogoIcon,
  LinkSimpleIcon,
  CheckIcon,
} from "@phosphor-icons/react";

export function BlogShareButtons({
  title,
  url,
}: {
  title: string;
  url: string;
}) {
  const [copied, setCopied] = useState(false);

  const encodedTitle = encodeURIComponent(title);
  const encodedUrl = encodeURIComponent(url);

  const shareLinks = [
    {
      name: "WhatsApp",
      icon: WhatsappLogoIcon,
      href: `https://api.whatsapp.com/send?text=${encodedTitle}%20${encodedUrl}`,
      className: "blog-share-btn--whatsapp",
    },
    {
      name: "X (Twitter)",
      icon: XLogoIcon,
      href: `https://twitter.com/intent/tweet?text=${encodedTitle}&url=${encodedUrl}`,
      className: "blog-share-btn--x",
    },
    {
      name: "Facebook",
      icon: FacebookLogoIcon,
      href: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
      className: "blog-share-btn--facebook",
    },
    {
      name: "LinkedIn",
      icon: LinkedinLogoIcon,
      href: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
      className: "blog-share-btn--linkedin",
    },
  ];

  const handleCopy = async () => {
    try {
      if (typeof window !== "undefined" && navigator.clipboard) {
        await navigator.clipboard.writeText(url);
        setCopied(true);
        setTimeout(() => setCopied(false), 2500);
      }
    } catch {
      // ignore
    }
  };

  return (
    <div className="blog-share">
      <span className="blog-share__title">Paylaş:</span>
      <div className="blog-share__items">
        {shareLinks.map((item) => {
          const Icon = item.icon;
          return (
            <a
              key={item.name}
              href={item.href}
              target="_blank"
              rel="noopener noreferrer"
              className={`blog-share-btn ${item.className}`}
              aria-label={`${item.name}'ta Paylaş`}
              title={`${item.name}'ta Paylaş`}
            >
              <Icon size={18} weight="bold" />
            </a>
          );
        })}
        <button
          type="button"
          onClick={handleCopy}
          className={`blog-share-btn blog-share-btn--copy ${copied ? "blog-share-btn--copied" : ""}`}
          aria-label={copied ? "Kopyalandı" : "Bağlantıyı Kopyala"}
          title={copied ? "Kopyalandı!" : "Bağlantıyı Kopyala"}
        >
          {copied ? <CheckIcon size={18} weight="bold" /> : <LinkSimpleIcon size={18} weight="bold" />}
        </button>
      </div>
    </div>
  );
}
